import React from "react";
import { Residents } from "../../components";

export default function Invite() {
  return (
    <div>
      <>
        <Residents />
      </>
    </div>
  );
}
